import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useMembership } from '../../../contexts/MembershipServiceContext';
import OrderConfirmation from '../../../components/OrderConfirmation';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const OrderConfirmationPage = () => {
	const { t } = useTranslation('orderConfirmation');
	const navigate = useNavigate();
	const { membershipListData } = useMembership();

	const { result: submitResult, hasCompleted } = useSelector(
		(state) => state.customerDetailsSlice.postNewMembershipSignup
	);

	const { result: browserResult } = useSelector(
		(state) => state.customerDetailsSlice.postBrowserDetails
	);

	const hasValidOrder = hasCompleted && submitResult;

	if (!hasValidOrder) {
		return (
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					py: 8,
					px: 2,
					textAlign: 'center'
				}}
			>
				<Typography variant='h4' sx={{ fontWeight: 600, mb: 2 }}>
					{t('noOrderTitle')}
				</Typography>
				<Typography
					variant='body1'
					color='text.secondary'
					sx={{ mb: 4, maxWidth: 400 }}
				>
					{t('noOrderMessage')}
				</Typography>
				<Stack direction='row' spacing={2}>
					<Button
						variant='contained'
						onClick={() => navigate('/')}
						sx={{ textTransform: 'none' }}
					>
						{t('goToCart')}
					</Button>
					<Button
						variant='outlined'
						onClick={() => {
							window.location.href = `mailto:${membershipListData?.contactEmail}?subject=Support%20Request`;
						}}
						sx={{ textTransform: 'none' }}
					>
						{t('contactSupport')}
					</Button>
				</Stack>
			</Box>
		);
	}

	return (
		<OrderConfirmation
			membershipListData={membershipListData}
			submitResult={submitResult}
			browserResult={browserResult}
		/>
	);
};

export default OrderConfirmationPage;
